'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var Variable;
(function (Variable) {
    Variable.TAG_ARRAY = '[object Array]';
    Variable.TAG_GLOBAL = '[object global]';
    Variable.TAG_NUMBER = '[object Number]';
    Variable.TAG_OBJECT = '[object Object]';
    Variable.TAG_STRING = '[object String]';
    Variable.TAG_WINDOW = '[object Window]';
    function tag(value) {
        return Object.prototype.toString.call(value);
    }
    Variable.tag = tag;
})(Variable = exports.Variable || (exports.Variable = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/variable.ts
// module id = 39
// module chunks = 0 1